import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { lg, md, xl } from '../common';

export function initNewsSlider() {
  const parent = document.querySelector('.news-slider');
  if (!parent) return;

  const prevEl = parent.querySelector('.swiper-button-prev');
  const nextEl = parent.querySelector('.swiper-button-next');

  new Swiper('.news-slider__swiper .swiper', {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 12,
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      560: {
        slidesPerView: 2,
      },
      [lg]: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      [xl]: {
        slidesPerView: 'auto',
        spaceBetween: 20,
      },
    },
  });
}
